/**
 * Practice-tab query hooks. Same shape as `use-inbox.ts`: key on the semantic
 * filter set (not the raw URL), 60s stale time, and `useFilteredQuery` so the
 * values leave the screen while a recount runs instead of the previous
 * selection's numbers sitting there looking current.
 *
 * TWO HOOKS AND NOT ONE, matching the two endpoints: the quarterly shape and
 * the drill list answer different questions and are wanted at different times.
 */

import { keepPreviousData } from '@tanstack/react-query';

import { useFilteredQuery } from '@/hooks/use-filtered-query';
import { filtersQuestion, type Filters } from '@/lib/filters-schema';
import { fetchPracticeDrills, fetchPracticeQuarter } from '@/services/practice-api';
import type { PracticeDrillRow, PracticeQuarterRow } from '@/services/api-types';

export function usePracticeQuarter(filters: Filters) {
  return useFilteredQuery<PracticeQuarterRow[]>({
    queryKey: ['practice', 'quarter', filtersQuestion(filters)],
    queryFn: async () => (await fetchPracticeQuarter(filters)).data,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}

export function usePracticeDrills(filters: Filters) {
  return useFilteredQuery<PracticeDrillRow[]>({
    queryKey: ['practice', 'drills', filtersQuestion(filters)],
    queryFn: async () => (await fetchPracticeDrills(filters)).data,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
